<section id="blog-detail" *ngIf="$blogPostMetadata | async as blogPost">
	<div class="bread-crumb">
		<a href="https://clearcals.com/">Home</a> > <a href="https://clearcals.com/blogs">Blog</a> >
		{{ blogPost.title }}
	</div>

	<clearcals-download-app-banner-mobile></clearcals-download-app-banner-mobile>

	<div class="blog-wrapper">
		<div class="grid-container">
			<div class="grid-col-1">
				<div class="blog-header">
					<h1 class="title-text">
						{{ blogPost.title }}
					</h1>
					<div class="blog-header__meta">
						<div class="left">
							<div class="date">
								<ic-icon [icon]="calenderIcon"></ic-icon>
								<span>
									{{
									blogPost?.lastModified
									? (blogPost?.lastModified | date: 'MMMM d, y')
									: (blogPost?.createdDate | date: 'MMMM d, y')
									}}
								</span>
							</div>
						</div>
						<div class="right">
							<div class="read-time">
								<ic-icon [icon]="timeIcon"></ic-icon>
								<spans>{{ blogPost?.readingTime | number: '1.0-0' }} min read</spans>
							</div>
						</div>
					</div>
				</div>

				<div class="blog-container">
					<div fxLayout="column">
						<div class="blog-image">
							<img [src]="isSmall ? blogPost.listImage : blogPost.image" [alt]="blogPost.title"
								height="530" width="800" />
						</div>

						<scully-content></scully-content>
					</div>

					<clearcals-store-banner></clearcals-store-banner>

					<div class="blog-social-container">
						<span>Share this</span>
						<div class="blog-social">
							<a [href]="'https://www.facebook.com/sharer/sharer.php?' + hostName + blogPost.route"
								target="_blank" aria-label="Facebook share">
								<ic-icon [icon]="facebookIcon"></ic-icon>
							</a>

							<a [href]="
									'https://www.linkedin.com/shareArticle?mini=true&url=' + hostName + blogPost.route
								" target="_blank" aria-label="LinkedIn Share">
								<ic-icon [icon]="linkedinIcon"></ic-icon>
							</a>

							<a [href]="'https://twitter.com/share?url=' + hostName + blogPost.route" target="_blank"
								aria-label="Twitter Share">
								<ic-icon [icon]="twitterIcon"></ic-icon>
							</a>
						</div>
					</div>

					<mat-divider class="promo-mobile-divider"></mat-divider>

					<div #socialMediaBanner (click)="clickShopNow()" class="promo-mobile">
						<a href="/store/garmin-watches" target="_blank">
							<img src="https://img.clearcals.com/site/images/hint/garmin_watches_banner_desktop.webp"
								alt="Garmin watches banner" width="430" height="317" ngLazyLoadImage />
						</a>
					</div>

					<mat-divider class="social-media-divider"></mat-divider>

					<div class="blog-pager" fxFlex="100" fxLayout="row" fxLayout.lt-sm="column"
						fxLayoutAlign="space-between center" fxLayoutAlign.lt-sm="start center">
						<div class="blog-pager-left" fxLayout="column" fxFlex="50">
							<a [routerLink]="previousBlog.route" fxLayout="row" fxLayoutAlign="start center"
								fxLayoutGap="16px">
								<div>
									<h4 class="content">
										{{ previousBlog.title }}
									</h4>
								</div>
								<div class="blog-pager-image">
									<img [src]="previousBlog.listImage" [alt]="previousBlog.title" ngLazyLoadImage />
									<div class="blog-pager-content" fxLayout="row" fxLayoutGap="10px"
										fxLayoutAlign="end center">
										<ic-icon [icon]="arrowLeftIcon"></ic-icon>
										<h3 class="heading-4 title-text">PREV</h3>
									</div>
								</div>
							</a>
						</div>

						<div class="blog-pager-right" fxLayout="column" fxFlex="50">
							<a [routerLink]="nextBlog.route" fxLayout="row" fxLayoutAlign="end center"
								fxLayoutGap="16px">
								<div class="blog-pager-image">
									<img [src]="nextBlog.listImage" [alt]="nextBlog.title" ngLazyLoadImage />
									<div class="blog-pager-content" fxLayout="row" fxLayoutGap="10px"
										fxLayoutAlign="start center">
										<h3 class="heading-4 title-text">NEXT</h3>
										<ic-icon [icon]="arrowRightIcon"></ic-icon>
									</div>
								</div>
								<div>
									<h4 class="content">
										{{ nextBlog.title }}
									</h4>
								</div>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="grid-col-2">
				<clearcals-download-app-banner-desktop></clearcals-download-app-banner-desktop>
				<div class="promo" #socialMediaBanner (click)="clickShopNow()">
					<a href="/store/garmin-watches" target="_blank">
						<img src="https://img.clearcals.com/site/images/hint/garmin_watches_banner_desktop.webp"
							alt="Garmin watches banner" width="300" height="367" />
					</a>
				</div>
			</div>
		</div>
	</div>
</section>